const emptyFunction = <P>(_element?: P): void => {};

export default emptyFunction;
